import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const NetworkTileBtcPerCountry = ({ data, formatNumber, animate }) => {
  const numberValue = data
    ? `${formatNumber((21000000 / 195), 0) ?? "Loading..."} BTC`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Per Country" value={numberValue} />
    </ThemedFlex>
  );
};
